import "./Toolbar.css"

export default function Toolbar({ children }) {
  return (
    <>
      <div className="object-list-header mt-3 px-3 md:px-5 lg:h-10">
        {children}
      </div>
      <hr className="mx-3 my-2 md:mx-5 md:my-3" />
    </>
  )
}

function Actions({ children }) {
  return (
    <div className="flex max-w-sm flex-col items-end space-y-3 self-end md:max-w-md lg:max-w-none lg:flex-row lg:items-center lg:space-x-4 lg:space-y-0 lg:self-center">
      {children}
    </div>
  )
}

function Heading({ children }) {
  return (
    <div className="flex flex-col-reverse space-y-2 space-y-reverse lg:flex-row lg:items-center lg:space-x-2 lg:space-y-0">
      {children}
    </div>
  )
}

Toolbar.Heading = Heading
Toolbar.Actions = Actions
